import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrows",
  "use": "arrows-usage",
  "viewBox": "0 0 141 81",
  "content": "<symbol viewBox=\"0 0 141 81\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrows\">\n<path d=\"M38.125 34.25H94.375V59.875H38.125V80.5L0 46.75L38.125 13V34.25Z\" fill=\"#03ADEF\" fill-opacity=\"0.32\" />\n<g style=\"mix-blend-mode:plus-darker\">\n<path d=\"M140.859 34.25L102.734 68V46.75H47.1094V21.125H102.734V0.5L140.859 34.25Z\" fill=\"#0165DF\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol